// services/email/SaleEmailService.ts

import { saleApi } from '../../api';

const SaleEmailService = {
  sendSaleEmail: async (saleId: number) => {
    const response =
      await saleApi.addWithoutData(
        `/${saleId}/email`
      );

    return response.data;
  },
};

export default SaleEmailService;